module.exports = __webpack_public_path__ + "img/gfiretail.2fee55db.png";